import { render, staticRenderFns } from "./LastChanceComponent.vue?vue&type=template&id=82c8f0c8&"
import script from "./LastChanceComponent.vue?vue&type=script&lang=js&"
export * from "./LastChanceComponent.vue?vue&type=script&lang=js&"
import style0 from "./LastChanceComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports